import { render, staticRenderFns } from "./Tokenomic.vue?vue&type=template&id=7b9fe676&scoped=true"
import script from "./Tokenomic.vue?vue&type=script&lang=js"
export * from "./Tokenomic.vue?vue&type=script&lang=js"
import style0 from "./Tokenomic.vue?vue&type=style&index=0&id=7b9fe676&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9fe676",
  null
  
)

export default component.exports